// extracted by mini-css-extract-plugin
export default {"landingPage":"Campaign_landingPage__GNgdY","landingImg":"Campaign_landingImg__H6U75","tcButton":"Campaign_tcButton__B7fd1"};